import _extends from 'babel-runtime/helpers/extends';
import filter from 'lodash/filter';
import flatten from 'lodash/flatten';
import * as converter from 'xml-js';

import { contentTypes, stepTypes } from '../step/step-constants';
import { stepModel } from '../step/step-model';

var NOT_SIL = '!SIL';

var LISTEN = 'Listen';
var READ = 'Read';
var SPEAK = 'Speak';

function isReadAloud(step) {
  if (step.type !== stepTypes.PHONEME) {
    return false;
  }
  var xmlAlignmentData = getXmlAlignmentData(step);
  return !!xmlAlignmentData;
}

// xmlToJson() converts xml to json using an external lib
var xmlToJson = function xmlToJson(xml) {
  if (!xml) return;
  var json = converter.xml2json(xml, {
    compact: true,
    spaces: 2
  });
  return typeof json === 'string' ? JSON.parse(json) : json;
};

// indexJson() takes the converted xml to json data and adds an index
//  used by reading tracker sessions. Separates the words from
//  the spacer alignment objects.
var indexJson = function indexJson(json) {
  if (!json) return;

  var wordlist = filter(json.readingtracker_alignment.words.word, function (word) {
    return word._attributes.text !== NOT_SIL;
  });
  var spacers = filter(json.readingtracker_alignment.words.word, function (word) {
    return word._attributes.text === NOT_SIL;
  });
  json.readingtracker_alignment.words.word = wordlist;
  json.readingtracker_alignment.spacers = spacers;

  for (var i = 0; i < wordlist.length; i++) {
    wordlist[i] = _extends({}, wordlist[i]._attributes);
    var word = wordlist[i];
    word.index = i;
  }
  return json;
};

// getXmlAlignmentData() is broken out from parseReadAloudData so
//  it can be shared as a way to determine if a 'phoneme' type step
//  is readAloud or pronunciation
function getXmlAlignmentData(step) {
  var alignmentData = null;
  if (step && step.content) {
    var flatContent = flatten(step.content);
    var audiosContent = stepModel.getContent(flatContent, contentTypes.AUDIOS);
    if (audiosContent) {
      alignmentData = audiosContent.alignmentXmlPrompt;
    }
  }
  return alignmentData;
}

function parseReadAloudData(step) {
  var content = flatten(step.content);
  var audios = stepModel.parseContentByType(contentTypes.AUDIOS, content);
  var images = stepModel.parseContentByType(contentTypes.IMAGES, content);
  var text = stepModel.parseContentByType(contentTypes.TEXT, step.content);

  var xml = getXmlAlignmentData(step);
  var json = xmlToJson(xml);
  var indexed = indexJson(json);
  var passage = text[0];

  var data = {
    passage: passage,
    prompts: {
      audios: audios,
      images: images
    },
    alignment: {
      words: indexed.readingtracker_alignment.words.word
    }
  };
  return data;
}

export var readAloudModel = {
  LISTEN: LISTEN,
  READ: READ,
  SPEAK: SPEAK,
  isReadAloud: isReadAloud,
  getXmlAlignmentData: getXmlAlignmentData,
  parseReadAloudData: parseReadAloudData
};